function n(e, l) {
  var t = e.length;
  for (e.sort(l); t--; )
    e[t] = e[t].value;
  return e;
}
var o = n;
export {
  o as default
};
//# sourceMappingURL=_baseSortBy.js.map
